module.exports = __webpack_public_path__ + "img/exclusive_icons.ffe5a817.svg";